import React from "react";
import { motion } from "framer-motion";
import {
  Github,
} from "lucide-react";
import TutorialSections from "./Tutorials";

const Ecosystem = () => {
  return (
    <section
      id="features"
      className="relative overflow-hidden py-12"
    >
      <div className="pointer-events-none absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-repeat opacity-20"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'><g fill='none' stroke='%233BCF8E' stroke-width='1.5' stroke-linecap='round'><path d='M8 8l8 8M16 8l-8 8'/><circle cx='30' cy='30' r='5'/></g></svg>\")",
            backgroundSize: "40px 40px",
            WebkitMaskImage:
              "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.9) 40%, rgba(0,0,0,0) 100%)",
            maskImage:
              "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.9) 40%, rgba(0,0,0,0) 100%)",
          }}
        />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl space-y-12 px-4">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="inline-flex flex-col items-center gap-6"
          >
            <motion.div
              initial={{ scale: 0.8 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ type: "spring", stiffness: 150 }}
              className="p-3.5 rounded-xl bg-[#3BCF8E]/10 border border-[#3BCF8E]/20 backdrop-blur-sm"
            >
              <Github className="h-12 w-12 text-[#3BCF8E] transition-transform hover:scale-110" />
            </motion.div>
            <h2 className="text-3xl md:text-6xl font-extrabold text-white tracking-tight">
              Built for the{" "}
              <span className="bg-gradient-to-r from-[#3BCF8E] to-[#2EA672] bg-clip-text text-transparent">
                GitHub
              </span>{" "}
              Ecosystem
            </h2>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
              viewport={{ once: true }}
              className="text-xl text-gray-300/90 max-w-2xl mx-auto mt-4 leading-relaxed"
            >
              Seamless native integration supercharging your GitHub workflow
              with AI-powered code analysis, intelligent automation, and
              real-time team collaboration insights.
            </motion.p>
          </motion.div>
        </div>
        <TutorialSections/>
      </div>
    </section>
  );
};

export default Ecosystem;